import { Operation as LogOperation, Log, LogCategory } from '@augloop/logging';
import { TypeCategory } from '@augloop/schemas';
import { Annotation, SchemaObject, Signal, DeltaUpdateOperation, UpdateAnnotationMetaDataOperation } from '@augloop/types-core';
import equal from 'fast-deep-equal';
export class Utils {
    static createHealthCheckRequest(clientMetadata) {
        return {
            payload: {},
            payloadSchema: { category: TypeCategory.Schema, schema: { name: 'HealthCheckRequest' } },
            requestedSchema: { category: TypeCategory.Schema, schema: { name: 'HealthCheckResponse' } },
            clientMetadata: clientMetadata
        };
    }
    static isFeatureEnabled(hostCallbacks, featureName, defaultValue = false, scope = 'None') {
        return hostCallbacks && hostCallbacks.isFeatureEnabled
            ? hostCallbacks.isFeatureEnabled('Microsoft.Office.AugLoop.' + featureName, scope)
                .catch(() => Promise.resolve(defaultValue))
            : Promise.resolve(defaultValue);
    }
    static convertWebSocketUrlToHttp(webSocketUrl) {
        return this.convertUrl(webSocketUrl, false);
    }
    static convertServiceUrlToWebSocket(serviceUrl) {
        return this.convertUrl(serviceUrl, true);
    }
    static convertUrl(url, convertToWs /** true for ws(s), false for http(s) */) {
        if (!url) {
            return url;
        }
        const urlOnColon = url.split(':');
        let serviceProtocol = urlOnColon[0].toLowerCase();
        if (serviceProtocol.indexOf(convertToWs ? 'http' : 'ws') == 0) {
            serviceProtocol = convertToWs ? serviceProtocol.replace('http', 'ws') : serviceProtocol.replace('ws', 'http');
            urlOnColon[0] = serviceProtocol;
            return urlOnColon.join(':');
        }
        return url;
    }
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    static deepEquals(a, b) {
        return equal(a, b);
    }
}
/**
 * Gets current time, expressed in milliseconds since 00:00 UTC 1 Jan 1970.
 * Note that older versions of some browsers can produce NaN as result.
 */
Utils.getCurrentTimeMs = () => {
    return Date.now ? Date.now() : new Date().getTime();
};
export class LogCountLimiter {
    constructor(id) {
        this.maxNumberOfLogs = 40;
        this.numberOfLogs = 0;
        this.id = id;
    }
    log(logCode) {
        if (this.numberOfLogs < this.maxNumberOfLogs) {
            this.numberOfLogs++;
            logCode();
            if (this.numberOfLogs === this.maxNumberOfLogs) {
                const op = new LogOperation({
                    operationName: 'OnLastLog',
                    success: true,
                    resourceId: this.id,
                    resultDescription: `Limit for number of logs for id: ${this.id} reached - all next logs will be dropped`,
                });
                Log.warn(0x2224d0db /* tag_8jnd1 */, LogCategory.CoreDefault, op);
            }
        }
    }
}
const coreBaseTypes = [SchemaObject.getTypeName(), Annotation.getTypeName(), Signal.getTypeName()];
export const buildArrayOfTypes = (types) => {
    const finalTypes = new Set();
    for (const singleType of types) {
        if (typeof singleType === 'string') {
            if (coreBaseTypes.indexOf(singleType) === -1) {
                finalTypes.add(singleType);
            }
        }
        else {
            for (const type of [singleType.getTypeName(), ...singleType.getBaseTypes()]) {
                if (coreBaseTypes.indexOf(type) === -1) {
                    finalTypes.add(type);
                }
            }
        }
    }
    return Array.from(finalTypes);
};
/**
 * Returns the provided value if finite; otherwise, returns the default value.
 * @param value The preferred value, if finite.
 * @param defaultValue The failsafe value.
 */
export const getSafeNumber = (value, defaultValue = 0) => {
    return Number.isFinite(value)
        ? value
        : defaultValue;
};
export const isServerOp = (op, serverInputTypes) => {
    if (!Array.isArray(serverInputTypes) || serverInputTypes.length === 0) {
        return true;
    }
    if (DeltaUpdateOperation.typeGuard(op) || UpdateAnnotationMetaDataOperation.typeGuard(op)) {
        return true;
    }
    for (const opItem of op.items) {
        if (!opItem.body || SchemaObject.matchesTypesFor(opItem.body, serverInputTypes)) {
            return true;
        }
    }
    return false;
};
//# sourceMappingURL=utils.js.map